import type { ErrorProcessor } from "@/types/ErrorProcessor";
import type { ServerErrors } from "@/types/ServerError";
import { usePaymentMethodsErrorsStore } from "@/payment/usePaymentMethodsErrorsStore";

// The confirm endpoint rejects a platform payment whose gateway payload has no
// nonce under this key (ConfirmPaymentRequest::validateGatewayPayload). It is
// the one payment error the donor can act on from the payment step: choose and
// authorise the method again. Gateway declines arrive under `payment` and keep
// going to the generic banner.
const PAYMENT_METHOD_ERROR_PATHS = ["payment.gateway_payload.nonce"];

function messagesFor(serverErrors: ServerErrors): string[] {
  return PAYMENT_METHOD_ERROR_PATHS.flatMap((path) =>
    Array.isArray(serverErrors[path]) ? serverErrors[path] : [],
  );
}

export function usePaymentMethodsErrorsProcessor(): ErrorProcessor {
  return {
    name: "payment_methods",
    test: (serverErrors: ServerErrors) => messagesFor(serverErrors).length > 0,
    execute: (serverErrors: ServerErrors) => {
      const [message] = messagesFor(serverErrors);

      if (message) {
        // Read the store directly: the processor is registered once on mount,
        // so a hook-bound setter would go stale.
        usePaymentMethodsErrorsStore.getState().setErrors({ payment: message });
      }
    },
  };
}
